module.exports = __webpack_public_path__ + "static/media/secretaire_full.f6b6c7e3.jpg";